import { HStack, Link, LinkProps, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { IMaterialIconProps, MaterialIcon } from "./MaterialIcon";

interface IMutedLinkProps extends LinkProps {
  to: string;
  label: string;
  iconName?: IMaterialIconProps["name"];
}

export const MutedLink = (props: IMutedLinkProps) => {
  const { to, label, iconName } = props;
  return (
    <Link
      as={RouterLink}
      to={to}
      role="group"
      whiteSpace="nowrap"
      fontSize="md"
      _hover={{
        textDecoration: "none",
        color: "text.soft",
      }}
    >
      <HStack>
        {iconName && (
          <MaterialIcon
            name={iconName}
            fontSize="1.5rem"
            display="block"
            variant="outline"
            color={"text.primary"}
            _groupHover={{ color: "text.soft" }}
          />
        )}

        <Text _groupHover={{ color: "text.soft" }} color={"text.primary"}>
          {label}
        </Text>
      </HStack>
    </Link>
  );
};
